import React from 'react';
import { ForgotPassword } from '../../components/ForgotPassword';

export const ForgotPasswordPage: React.FC = () => {
    return <ForgotPassword />;
};
